"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _communityComment = require("@/api/community/communityComment");
var _memberManagement = require("@/api/member/memberManagement");
var _topicManagement = require("@/api/community/topicManagement");
var _avatarManagement = require("@/api/community/avatarManagement");
var _popupConfig = require("@/api/popup/popupConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CreateActivityTemplate',
  data: function data() {
    return {
      // 新增表单数据
      createForm: {
        title: '',
        content: '',
        coverImage: '',
        figure: '',
        topic: '',
        category: '',
        notifyUser: 0,
        isNotice: 0,
        // 分类相关字段
        externalLink: '',
        // 外链地址 (分类2)
        systemLink: '',
        // 系统链接 (分类3)
        imageFile: '' // 图片文件 (分类4)
      },
      imageurl: '',
      typeImageUrl: '',
      // 新增表单验证规则
      createRules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: '请输入内容',
          trigger: 'blur'
        }],
        coverImage: [{
          required: true,
          message: '请上传封面图',
          trigger: 'change'
        }],
        figure: [{
          required: true,
          message: '请选择形象',
          trigger: 'change'
        }],
        topic: [{
          required: true,
          message: '请选择话题',
          trigger: 'change'
        }],
        category: [{
          required: true,
          message: '请选择分类',
          trigger: 'change'
        }]
      },
      imagePrefix: '',
      // 话题列表数据
      topicList: [],
      // 形象列表数据
      avatarList: [],
      // 系统链接页面列表数据（仅社区 GAGAS）
      pageList: []
    };
  },
  watch: {
    // 监听分类变化，动态调整验证规则
    'createForm.category': {
      handler: function handler(newVal) {
        // 清除之前的条件验证规则
        this.$delete(this.createRules, 'externalLink');
        this.$delete(this.createRules, 'systemLink');
        this.$delete(this.createRules, 'imageFile');

        // 根据当前分类添加相应的验证规则
        if (newVal === '2') {
          // 外链
          this.$set(this.createRules, 'externalLink', [{
            required: true,
            message: '请输入外链地址',
            trigger: 'blur'
          }]);
        } else if (newVal === '3') {
          // 系统链接
          this.$set(this.createRules, 'systemLink', [{
            required: true,
            message: '请选择系统链接',
            trigger: 'change'
          }]);
        } else if (newVal === '4') {
          // 图片
          this.$set(this.createRules, 'imageFile', [{
            required: true,
            message: '请上传图片',
            trigger: 'change'
          }]);
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // 获取图片前缀
    this.fetchImagePrefix();
    // 获取话题列表
    this.getTopicList();
    // 获取形象列表
    this.getAvatarList();
    // 获取系统链接页面列表
    this.getPageList();
  },
  methods: {
    // 获取图片前缀
    fetchImagePrefix: function () {
      var _fetchImagePrefix = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchImagePrefix() {
        return _fetchImagePrefix.apply(this, arguments);
      }
      return fetchImagePrefix;
    }(),
    // 获取完整图片URL
    getImageUrl: function getImageUrl(imgPath) {
      // 如果已经是完整URL，则直接返回
      if (imgPath && (imgPath.startsWith('http://') || imgPath.startsWith('https://'))) {
        return imgPath;
      }

      // 使用动态获取的图片前缀
      return imgPath ? this.imagePrefix + imgPath : '';
    },
    goBack: function goBack() {
      // 通过事件通知父组件关闭当前标签页
      this.$emit('go-back');
    },
    // 图片上传前处理
    beforeUpload: function beforeUpload(file) {
      // 支持的图片格式
      var allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
      var isImage = allowedTypes.includes(file.type);
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('不支持的图片格式，请上传 jpg、png、gif、bmp、webp 等格式图片!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isImage && isLt2M;
    },
    // 处理图片上传
    handleUpload: function handleUpload(option) {
      var _this = this;
      // 创建FormData对象
      var formData = new FormData();
      formData.append('file', option.file);

      // 调用上传接口
      (0, _communityComment.uploadPic)(formData).then(function (response) {
        if (response.code === 200 && response.data) {
          // 判断是哪个字段的上传
          if (option.filename === 'imageFile') {
            // 分类4的图片上传
            _this.typeImageUrl = response.data;
            _this.createForm.imageFile = _this.getImageUrl(response.data);
          } else {
            // 默认封面图上传
            _this.imageurl = response.data;
            _this.createForm.coverImage = _this.getImageUrl(response.data);
          }
          option.onSuccess();
        } else {
          _this.$message.error(response.message || '上传失败');
          option.onError();
        }
      }).catch(function (error) {
        _this.$message.error('上传失败: ' + error.message);
        option.onError();
      });
    },
    // 提交表单（新增活动模板）
    submitForm: function submitForm() {
      var _this2 = this;
      // 检查表单引用是否存在
      if (!this.$refs.createFormref) {
        this.$message.warning('表单引用未找到，将跳过验证直接提交');
        this.submitFormData();
        return;
      }

      // 检查是否有 validate 方法
      if (typeof this.$refs.createFormref.validate !== 'function') {
        this.$message.warning('表单验证方法不可用，将跳过验证直接提交');
        this.submitFormData();
        return;
      }

      // 执行表单验证
      this.$refs.createFormref.validate(function (valid) {
        if (valid) {
          _this2.submitFormData();
        } else {
          _this2.$message.warning('请填写必填项');
          return false;
        }
      });
    },
    // 提交表单数据的实际方法
    submitFormData: function submitFormData() {
      var _this3 = this;
      // 构造请求参数
      var requestData = {
        title: this.createForm.title,
        content: this.createForm.content,
        imageURl: this.imageurl,
        figureId: this.createForm.figure,
        topic: this.createForm.topic,
        jumpType: this.createForm.category,
        userLevel: this.createForm.notifyUser,
        isNotice: this.createForm.isNotice
      };

      // 根据分类类型添加相应字段
      if (this.createForm.category === '2') {
        // 外链
        requestData.linkurl = this.createForm.externalLink;
      } else if (this.createForm.category === '3') {
        // 系统链接
        requestData.linkurl = this.createForm.systemLink;
      } else if (this.createForm.category === '4') {
        // 图片文件
        requestData.showImg = this.typeImageUrl;
      }

      // 调用新增活动模板接口
      (0, _communityComment.addActTemplate)(requestData).then(function (response) {
        if (response.code === 200) {
          _this3.$message.success('新增活动模板成功');
          // 通知父组件刷新数据
          _this3.$emit('refresh-data');
          // 关闭当前tab并返回到活动模板列表
          _this3.goBack();
        } else {
          _this3.$message.error(response.message || '新增失败');
        }
      }).catch(function (error) {
        _this3.$message.error('新增失败: ' + error.message);
      });
    },
    // 获取话题列表
    getTopicList: function () {
      var _getTopicList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _topicManagement.getTopicList)({
                page: 1,
                limit: 1000 // 获取所有话题
              });
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.records) {
                this.topicList = response.records;
              } else {
                this.$message.error('获取话题列表失败: ' + (response.message || '未知错误'));
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取话题列表错误：', _t2);
              this.$message.error('获取话题列表失败: ' + _t2.message);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getTopicList() {
        return _getTopicList2.apply(this, arguments);
      }
      return getTopicList;
    }(),
    // 获取形象列表
    getAvatarList: function () {
      var _getAvatarList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _avatarManagement.getAvatarList)({
                page: 1,
                limit: 1000 // 获取所有形象
              });
            case 1:
              response = _context3.sent;
              if (response.code === 200 && response.records) {
                this.avatarList = response.records;
              } else {
                this.$message.error('获取形象列表失败: ' + (response.message || '未知错误'));
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取形象列表错误：', _t3);
              this.$message.error('获取形象列表失败: ' + _t3.message);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getAvatarList() {
        return _getAvatarList2.apply(this, arguments);
      }
      return getAvatarList;
    }(),
    // 获取系统链接页面列表（只保留社区 GAGAS 页面）
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context4.sent;
              if (response.code === 200 && response.data) {
                this.pageList = response.data.filter(function (item) {
                  return item.appid === 'GAGAS';
                });
              } else {
                this.$message.error('获取系统链接列表失败: ' + (response.message || '未知错误'));
              }
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t4 = _context4["catch"](0);
              console.error('获取系统链接列表错误：', _t4);
              this.$message.error('获取系统链接列表失败: ' + _t4.message);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }()
  }
};